import React, { useState, useEffect } from "react";
import { Store } from "../Utility/Store";
import { fetchPOCData } from "../Utility/actions";
import {
  Card,
  Table,
  Checkbox,
  Icon,
  Button,
  Segment,
  Loader,
  Dimmer,
  Image,
} from "semantic-ui-react";
import ResultPagination from "../Utility/Pagination";
import { set_start_page, set_per_page } from "../Utility/actions";
import { Dropdown } from "semantic-ui-react";
export default function ResultContainer() {
  const { state, dispatch } = React.useContext(Store);
  const [toggleCard, setToggleCard] = useState(true);
  const server_url = "https://seed.nih.gov";
  const [sortStartup, setsortStartup] = useState(true);
  const [sortTitle, setsortTitle] = useState(true);
  const [sortProgram, setsortProgram] = useState(true);
  const [sortTechnology, setsortTechnology] = useState(true);
  const [sortCenter, setsortCenter] = useState(true);
  const [sortDisease, setsortDisease] = useState(true);
  const [sortInstitution, setsortInstitution] = useState(true);
  const [sortLicensing, setsortLicensing] = useState(true);
  const [sortStatus, setsortStatus] = useState(true);
  const [listView, setListView] = useState(false);
  const [gridView, setGridView] = useState(true);

  const perPage_options = [
    {
      key: "18",
      text: "18",
      value: 18,
    },
    {
      key: "36",
      text: "36",
      value: 36,
    },
    {
      key: "54",
      text: "54",
      value: 54,
    },
    {
      key: "108",
      text: "108",
      value: 108,
    },
  ];

  const toggle_card = () => {
    let card = toggleCard;
    setToggleCard(!card);
  };

  const grid = () => {
    setListView(false);
    setGridView(true);
  };

  const list = () => {
    setListView(true);
    setGridView(false);
  };

  const sortResultAsc = (field) => {
    switch (field) {
      case "start_up":
        setsortStartup(false);
        break;
      case "title":
        setsortTitle(false);
        break;
      case "program":
        setsortProgram(false);
        break;
      case "technology":
        setsortTechnology(false);
        break;
      case "centerhub":
        setsortCenter(false);
        break;
      case "disease":
        setsortDisease(false);
        break;
      case "institution":
        setsortInstitution(false);
        break;
      case "status":
        setsortStatus(false);
        break;
      case "licensing":
        setsortLicensing(false);
        break;
    }

    let obj = {
      query: state.query,
      program: state.program,
      center_hub: state.center,
      institutions: state.institutions,
      technology: state.technology,
      disease: state.disease,
      licensing: state.licensing,
      status: state.status,
      sort_field: field,
      sort_type: "asc",
    };
    fetchPOCData(dispatch, obj);
  };

  const sortResultDesc = (field) => {
    switch (field) {
      case "start_up":
        setsortStartup(true);
        break;
      case "title":
        setsortTitle(true);
        break;
      case "program":
        setsortProgram(true);
        break;
      case "technology":
        setsortTechnology(true);
        break;
      case "centerhub":
        setsortCenter(true);
        break;
      case "disease":
        setsortDisease(true);
        break;
      case "institution":
        setsortInstitution(true);
        break;
      case "status":
        setsortStatus(true);
        break;
      case "licensing":
        setsortLicensing(true);
        break;
    }
    let obj = {
      query: state.query,
      program: state.program,
      center_hub: state.center,
      institutions: state.institutions,
      technology: state.technology,
      disease: state.disease,
      licensing: state.licensing,
      status: state.status,
      sort_field: field,
      sort_type: "desc",
    };
    fetchPOCData(dispatch, obj);
  };

  let fetchResult = (e, { name, value }) => {
    set_start_page(dispatch, 1);
    set_per_page(dispatch, value);
    let obj = {
      query: state.query,
      program: state.program,
      center_hub: state.center,
      institutions: state.institutions,
      technology: state.technology,
      disease: state.disease,
      licensing: state.licensing,
      status: state.status,
      sort_type: "asc",
      sort_field: "",
      size: value,
    };
    fetchPOCData(dispatch, obj);
  };

  return (
    <div className="results_container">
      <div className="poc_container_utility">
        <div className="per_page_display ui form">
          <div>Display Per Page </div>
          <Dropdown
            selection
            options={perPage_options}
            placeholder="18"
            onChange={fetchResult}
            selectOnBlur={false}
            name="per_page"
            style={{
              minWidth: "20px",
              marginTop: "4px",
            }}
          />
        </div>

        <div className="grid-list-btn-container">
          <div
            className={
              gridView
                ? "grid-btn-container poc-active-view"
                : "grid-btn-container"
            }
            onClick={grid}
          >
            <Icon name="grid layout" /> Grid View
          </div>
          <div
            className={
              listView
                ? "list-btn-container poc-active-view"
                : "list-btn-container"
            }
            onClick={list}
          >
            <Icon name="table" /> List View
          </div>
        </div>
      </div>

      <h3>Results</h3>

      <div style={{ marginBottom: "15px" }}>
        {state.results && state.results.total ? (
          <div>
            {state.start_page <= 1
              ? 1
              : (state.start_page - 1) * state.per_page + 1}{" "}
            to{" "}
            {state.results.total.value < state.start_page * state.per_page
              ? state.results.total.value
              : state.start_page * state.per_page}{" "}
            of {state.results.total.value} results found
          </div>
        ) : (
          ""
        )}
      </div>

      {gridView ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignContent: "flex-start",
            alignItems: "strech",
          }}
        >
          {state.results.hits ? (
            state.results.hits.length > 0 ? (
              state.results.hits.map((item, index) => {
                return (
                  <div
                    style={{
                      flexBasis: "32%",
                      marginBottom: "10px",
                      marginRight: "10px",
                      backgroundColor: "#EFFAE2",
                      padding: "20px 40px",
                      border: "0.5px solid #9BB763",
                    }}
                    key={index + "_poc"}
                  >
                    <div className="poc_card">
                      <a href={server_url + item._source.url} target="_blank">
                        {item._source.title}
                      </a>
                      <ul className="meta_data">
                        <li>
                          <strong>University/Institution: </strong>
                          {item._source.field_poc_institutions}
                        </li>

                        {item._source.field_poc_startup_name ? (
                          <li>
                            <strong>Start Up Name: </strong>
                            {item._source.field_poc_startup_name}
                          </li>
                        ) : (
                          ""
                        )}

                        <li>
                          <strong>Technology Type: </strong>
                          {item._source.field_poc_technology_type}
                        </li>

                        <li>
                          <strong>Disease Area: </strong>
                          {item._source.field_poc_disease_area
                            ? item._source.field_poc_disease_area.length > 0
                              ? item._source.field_poc_disease_area.map(
                                  (poc, index) => {
                                    return index !=
                                      item._source.field_poc_disease_area
                                        .length -
                                        1 ? (
                                      <span key={index + "_poc_disease"}>
                                        {poc},{" "}
                                      </span>
                                    ) : (
                                      <span key={index + "_poc_disease"}>
                                        {poc}{" "}
                                      </span>
                                    );
                                  }
                                )
                              : ""
                            : ""}
                        </li>

                        <li>
                          <strong>Licensing Status: </strong>
                          {item._source.field_licensing_status}
                        </li>
                      </ul>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <a href={server_url + item._source.url} target="_blank">
                        MORE INFO
                      </a>
                    </div>
                  </div>
                );
              })
            ) : (
              ""
            )
          ) : (
            <Segment loading>
              <div style={{ width: "100%", height: "250px" }}></div>
            </Segment>
          )}
        </div>
      ) : (
        ""
      )}
      {listView ? (
        <div>
          <Table celled className="poc_table">
            <Table.Header>
              <Table.Row>
                {state.filter_display.program ? (
                  <Table.HeaderCell>
                    Program{" "}
                    <Icon
                      name="angle down"
                      onClick={() => sortResultAsc("program")}
                      style={{
                        cursor: "pointer",
                        display: sortProgram ? "inline-block" : "none",
                      }}
                    />
                    <Icon
                      name="angle up"
                      onClick={() => sortResultDesc("program")}
                      style={{
                        cursor: "pointer",
                        display: !sortProgram ? "inline-block" : "none",
                      }}
                    />
                  </Table.HeaderCell>
                ) : (
                  ""
                )}

                {state.filter_display.changeHub ? (
                  <Table.HeaderCell>
                    Center / <br /> Hub{" "}
                    <Icon
                      name="angle down"
                      onClick={() => sortResultAsc("centerhub")}
                      style={{
                        cursor: "pointer",
                        display: sortCenter ? "inline-block" : "none",
                      }}
                    />
                    <Icon
                      name="angle up"
                      onClick={() => sortResultDesc("centerhub")}
                      style={{
                        cursor: "pointer",
                        display: !sortCenter ? "inline-block" : "none",
                      }}
                    />
                  </Table.HeaderCell>
                ) : (
                  ""
                )}

                {state.filter_display.institution ? (
                  <Table.HeaderCell width={2}>
                    Institution{" "}
                    <Icon
                      name="angle down"
                      onClick={() => sortResultAsc("institution")}
                      style={{
                        cursor: "pointer",
                        display: sortInstitution ? "inline-block" : "none",
                      }}
                    />
                    <Icon
                      name="angle up"
                      onClick={() => sortResultDesc("institution")}
                      style={{
                        cursor: "pointer",
                        display: !sortInstitution ? "inline-block" : "none",
                      }}
                    />
                  </Table.HeaderCell>
                ) : (
                  ""
                )}

                {state.filter_display.technology ? (
                  <Table.HeaderCell width={2}>
                    Technology{" "}
                    <Icon
                      name="angle down"
                      onClick={() => sortResultAsc("technology")}
                      style={{
                        cursor: "pointer",
                        display: sortTechnology ? "inline-block" : "none",
                      }}
                    />
                    <Icon
                      name="angle up"
                      onClick={() => sortResultDesc("technology")}
                      style={{
                        cursor: "pointer",
                        display: !sortTechnology ? "inline-block" : "none",
                      }}
                    />
                  </Table.HeaderCell>
                ) : (
                  ""
                )}

                {state.filter_display.disease ? (
                  <Table.HeaderCell width={2}>
                    Disease{" "}
                    <Icon
                      name="angle down"
                      onClick={() => sortResultAsc("disease")}
                      style={{
                        cursor: "pointer",
                        display: sortDisease ? "inline-block" : "none",
                      }}
                    />
                    <Icon
                      name="angle up"
                      onClick={() => sortResultDesc("disease")}
                      style={{
                        cursor: "pointer",
                        display: !sortDisease ? "inline-block" : "none",
                      }}
                    />
                  </Table.HeaderCell>
                ) : (
                  ""
                )}

                <Table.HeaderCell width={4}>
                  Project Title{" "}
                  <Icon
                    name="angle down"
                    onClick={() => sortResultAsc("title")}
                    style={{
                      cursor: "pointer",
                      display: sortTitle ? "inline-block" : "none",
                    }}
                  />
                  <Icon
                    name="angle up"
                    onClick={() => sortResultDesc("title")}
                    style={{
                      cursor: "pointer",
                      display: !sortTitle ? "inline-block" : "none",
                    }}
                  />
                </Table.HeaderCell>

                <Table.HeaderCell width={2}>
                  Start up <br />
                  name{" "}
                  <Icon
                    name="angle down"
                    onClick={() => sortResultAsc("start_up")}
                    style={{
                      cursor: "pointer",
                      display: sortStartup ? "inline-block" : "none",
                    }}
                  />{" "}
                  <Icon
                    name="angle up"
                    onClick={() => sortResultDesc("start_up")}
                    style={{
                      cursor: "pointer",
                      display: !sortStartup ? "inline-block" : "none",
                    }}
                  />
                </Table.HeaderCell>

                {state.filter_display.licensing ? (
                  <Table.HeaderCell>
                    Licensing{" "}
                    <Icon
                      name="angle down"
                      onClick={() => sortResultAsc("licensing")}
                      style={{
                        cursor: "pointer",
                        display: sortLicensing ? "inline-block" : "none",
                      }}
                    />
                    <Icon
                      name="angle up"
                      onClick={() => sortResultDesc("licensing")}
                      style={{
                        cursor: "pointer",
                        display: !sortLicensing ? "inline-block" : "none",
                      }}
                    />
                  </Table.HeaderCell>
                ) : (
                  ""
                )}

                {state.filter_display.status ? (
                  <Table.HeaderCell onClick={() => sortResultAsc("status")}>
                    Status{" "}
                    <Icon
                      name="angle down"
                      style={{
                        cursor: "pointer",
                        display: sortStatus ? "inline-block" : "none",
                      }}
                    />
                    <Icon
                      name="angle up"
                      style={{
                        cursor: "pointer",
                        display: !sortStatus ? "inline-block" : "none",
                      }}
                    />
                  </Table.HeaderCell>
                ) : (
                  ""
                )}
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {state.results.hits
                ? state.results.hits.length > 0
                  ? state.results.hits.map((item, index) => {
                      return (
                        <Table.Row>
                          {state.filter_display.program ? (
                            <Table.Cell>
                              {item._source.field_poc_program}
                            </Table.Cell>
                          ) : (
                            ""
                          )}
                          {state.filter_display.changeHub ? (
                            <Table.Cell>
                              {item._source.field_poc_center_hub}
                            </Table.Cell>
                          ) : (
                            ""
                          )}
                          {state.filter_display.institution ? (
                            <Table.Cell>
                              {item._source.field_poc_institutions}
                            </Table.Cell>
                          ) : (
                            ""
                          )}
                          {state.filter_display.technology ? (
                            <Table.Cell>
                              {item._source.field_poc_technology_type}
                            </Table.Cell>
                          ) : (
                            ""
                          )}
                          {state.filter_display.disease ? (
                            <Table.Cell>
                              {item._source.field_poc_disease_area
                                ? item._source.field_poc_disease_area.map(
                                    (disease_item, index) => {
                                      return (
                                        <React.Fragment
                                          key={index + "disease_item"}
                                        >
                                          {index !==
                                          item._source.field_poc_disease_area
                                            .length -
                                            1
                                            ? disease_item + ", "
                                            : disease_item}
                                        </React.Fragment>
                                      );
                                    }
                                  )
                                : ""}
                            </Table.Cell>
                          ) : (
                            ""
                          )}
                          <Table.Cell>
                            <a
                              href={server_url + item._source.url}
                              target="_blank"
                            >
                              {item._source.title}
                            </a>
                          </Table.Cell>
                          <Table.Cell>
                            {item._source.field_poc_startup_name}
                          </Table.Cell>{" "}
                          {state.filter_display.licensing ? (
                            <Table.Cell>
                              {item._source.field_licensing_status}
                            </Table.Cell>
                          ) : (
                            ""
                          )}
                          {state.filter_display.status ? (
                            <Table.Cell>
                              {item._source.field_poc_completion_status}
                            </Table.Cell>
                          ) : (
                            ""
                          )}
                        </Table.Row>
                      );
                    })
                  : ""
                : ""}
            </Table.Body>
          </Table>
        </div>
      ) : (
        ""
      )}
      <div>
        <ResultPagination />
      </div>
    </div>
  );
}
